import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { isAuthenticated, role, isStudent, isCompany, isAdmin, email, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setDropdownOpen(false);
  }, [location]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <Link to="/" className="navbar-brand">
          <div className="navbar-brand-icon">M</div>
          <div className="navbar-brand-text">Million<span>Minds</span></div>
        </Link>

        <div className="navbar-nav">
          <Link to="/" className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`}>Home</Link>
          <Link to="/browse" className={`navbar-link ${location.pathname === '/browse' ? 'active' : ''}`}>Browse Jobs</Link>
          
          {isAuthenticated ? (
            <>
              {isStudent && (
                <Link to="/dashboard" className={`navbar-link ${location.pathname === '/dashboard' ? 'active' : ''}`}>Dashboard</Link>
              )}
              {isCompany && (
                <Link to="/company/dashboard" className={`navbar-link ${location.pathname === '/company/dashboard' ? 'active' : ''}`}>Company Dashboard</Link>
              )}
              {isAdmin && (
                <Link to="/admin" className={`navbar-link ${location.pathname === '/admin' ? 'active' : ''}`}>Admin Portal</Link>
              )}
            </>
          ) : (
            <>
              <Link to="/college/partner" className="navbar-link">For Colleges</Link>
            </>
          )}
        </div>

        <div className="navbar-actions">
          {isAuthenticated ? (
            <div className="dropdown">
              <div 
                className="navbar-avatar" 
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                {email ? email.charAt(0).toUpperCase() : 'U'}
              </div>
              
              {dropdownOpen && (
                <div className="dropdown-menu">
                  <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--gray-100)', fontSize: 'var(--text-xs)', color: 'var(--gray-500)' }}>
                    Signed in as<br/>
                    <strong style={{ color: 'var(--gray-900)' }}>{email}</strong>
                  </div>
                  
                  {isStudent && <Link to="/dashboard" className="dropdown-item">Dashboard</Link>}
                  {isCompany && <Link to="/company/dashboard" className="dropdown-item">Dashboard</Link>}
                  {isAdmin && <Link to="/admin" className="dropdown-item">Admin Panel</Link>}
                  
                  <div className="dropdown-divider"></div>
                  <button onClick={handleLogout} className="dropdown-item danger">Logout</button>
                </div>
              )}
            </div>
          ) : (
            <>
              <div className="hidden md:flex gap-2">
                <Link to="/login" className="btn btn-ghost btn-sm" style={{ color: 'white' }}>Login</Link>
                <Link to="/register" className="btn btn-primary btn-sm">Register</Link>
              </div>
            </>
          )}

          <div 
            className={`hamburger ${menuOpen ? 'open' : ''}`} 
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>

      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <Link to="/" className="navbar-link">Home</Link>
        <Link to="/browse" className="navbar-link">Browse Jobs</Link>
        {!isAuthenticated && (
          <>
            <Link to="/login" className="navbar-link">Login</Link>
            <Link to="/register" className="navbar-link">Register</Link>
            <Link to="/company/login" className="navbar-link">Company Login</Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
